import {DtmHomeDetail} from '../components/dtm/DtmHomeDetail';
import {DtmObjektyDetail} from '../components/dtm/DtmObjektyDetail';

export enum DtmTabs {
    HOME = 'home',
    OBJEKTY = 'objekty',
}

export const dtmTabs: string[] = Object.values(DtmTabs);

export const getDtmTabsCaption = (typ: string | DtmTabs): string => {
    switch (typ) {
        case DtmTabs.HOME:
            return 'Hlavní';
        case DtmTabs.OBJEKTY:
            return 'Objekty';
        default:
            return `_${typ}`;
    }
};

export const getDtmTabsContent = (typ: string | DtmTabs) => {
    switch (typ) {
        case DtmTabs.HOME:
            return DtmHomeDetail;
        case DtmTabs.OBJEKTY:
            return DtmObjektyDetail;
    }
};

export const getDtmTabsItems = (): {id: DtmTabs; name: string}[] => {
    return dtmTabs.map((t: DtmTabs): {id: DtmTabs; name: string} => ({id: t, name: getDtmTabsCaption(t)}));
};
